import React from 'react';
import { Input } from '../../shared';
import { DatePicker, TimePicker } from '../../client';

const EventDetailsForm = ({
  bookingData,
  errors,
  onInputChange
}) => {
  return (
    <div>
      <h2 className="text-xl sm:text-2xl font-bold text-black mb-6 sm:mb-8">
        Event Details
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
        <div>
          <DatePicker
            label="Event Date *"
            value={bookingData.eventDate}
            onChange={(value) => onInputChange('eventDate', value)}
            placeholder="Select event date"
            minDate={new Date().toISOString().split('T')[0]}
            required
            className={`w-full ${errors.eventDate ? 'border-red-500' : ''}`}
          />
          {errors.eventDate && (
            <p className="mt-1 text-sm text-red-600">{errors.eventDate}</p>
          )}
        </div>
        <div>
          <TimePicker
            label="Event Time *"
            value={bookingData.eventTime}
            onChange={(value) => onInputChange('eventTime', value)}
            placeholder="Select event time"
            format="24"
            step={15}
            required
            className={`w-full ${errors.eventTime ? 'border-red-500' : ''}`}
          />
          {errors.eventTime && (
            <p className="mt-1 text-sm text-red-600">{errors.eventTime}</p>
          )}
        </div>
        {/* <div>
          <label className="block text-sm font-semibold text-black mb-2">
            Duration (hours) *
          </label>
          <Input
            type="number"
            value={bookingData.duration}
            onChange={(e) => onInputChange('duration', e.target.value)}
            min="1"
            max="12"
            className={`w-full ${errors.duration ? 'border-red-500' : ''}`}
          />
          {errors.duration && (
            <p className="mt-1 text-sm text-red-600">{errors.duration}</p>
          )}
        </div> */}
        <div>
          <label className="block text-sm font-semibold text-black mb-2">
            Guest Count
          </label>
          <Input
            type="number"
            value={bookingData.guestCount}
            onChange={(e) => onInputChange('guestCount', e.target.value)}
            min="1"
            className="w-full"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-black mb-2">
            Event Type *
          </label>
          <Input
            type="text"
            value={bookingData.eventType}
            onChange={(e) => onInputChange('eventType', e.target.value)}
            placeholder="e.g., Wedding, Birthday, Corporate"
            required
            className={`w-full ${errors.eventType ? 'border-red-500' : ''}`}
          />
          {errors.eventType && (
            <p className="mt-1 text-sm text-red-600">{errors.eventType}</p>
          )}
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm font-semibold text-black mb-2">
            Event Location
          </label>
          <Input
            type="text"
            value={bookingData.location}
            onChange={(e) => onInputChange('location', e.target.value)}
            placeholder="Enter full event address"
            className="w-full"
          />
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm font-semibold text-black mb-2">
            Special Requests
          </label>
          <textarea
            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-black transition-colors text-sm"
            rows="4"
            value={bookingData.specialRequests}
            onChange={(e) => onInputChange('specialRequests', e.target.value)}
            placeholder="Any special requirements or requests..."
          />
        </div>
      </div>
    </div>
  );
};

export default EventDetailsForm;

